import type { Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import authConfig from "@/config/auth";

// Not used for the moment, but could be useful later
export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      //   if (action.payload.data.message === "Invalid JWT Token") {
      //     localStorage.removeItem(authConfig.storageTokenKeyName);
      //     // toast.error(LoginErrorMessage);
      //   }
      // }
      //
    }

    return next(action);
  };
